export default __webpack_public_path__ + "static/media/80-20.45a560e3.png";